module.exports = __webpack_public_path__ + "img/Syg_icon_sdfsdfsdf.ff67bed3.png";